export default __webpack_public_path__ + "75299275d9c54ab1e2877f56d6deda37.svg";